// #region imports

// --- Angular
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Subscription, combineLatest, distinctUntilChanged } from 'rxjs';

// --- HS Code
import { RespondentModel } from '../../../models';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

// #endregion

@Component({
  selector: 'hs-invite-previous-respondents-v2',
  templateUrl: './invite-previous-respondents-v2.component.html',
  styleUrls: ['./invite-previous-respondents-v2.component.scss']
})
export class InvitePreviousRespondentsV2Component implements OnInit, OnChanges, OnDestroy {

  @Input() previousRespondents: RespondentModel[] | null = null;
  @Input() respondents: RespondentModel[] | null = null;

  @Output() addClicked = new EventEmitter<RespondentModel>();

  addRespondentsDictionary: { [key: string]: boolean } = {};
  selectedRespondentId: string = '';

  private _isAddAllowedSubscription: Subscription = Subscription.EMPTY;
  private _previousRespondentsSubject$: BehaviorSubject<RespondentModel[] | null> = new BehaviorSubject<RespondentModel[] | null>(null);
  private _respondentsSubject$: BehaviorSubject<RespondentModel[] | null> = new BehaviorSubject<RespondentModel[] | null>(null);
  
  constructor(    
  ) {
    this._isAddAllowedSubscription = combineLatest({
      previousRespondents: this._previousRespondentsSubject$,
      respondents: this._respondentsSubject$
    }).subscribe(({ previousRespondents, respondents}) => {

      if (!previousRespondents || !respondents) {
        return;
      }

      previousRespondents.forEach(pr => {
        const foundRespondent = respondents.find(r => r.emailAddress.trim().toLowerCase() === pr.emailAddress.trim().toLowerCase());
        this.addRespondentsDictionary[pr.emailAddress] = !!foundRespondent;
      })
    });
  }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes && changes['previousRespondents']) {
        this._previousRespondentsSubject$.next(this.previousRespondents);
      }

      if (changes && changes['respondents']) {
        this._respondentsSubject$.next(this.respondents);
      }
  }

  ngOnDestroy(): void {
    if (this._isAddAllowedSubscription !== Subscription.EMPTY) {
      this._isAddAllowedSubscription.unsubscribe();
      this._isAddAllowedSubscription = Subscription.EMPTY;
    }
  }

  isAddAllowed(respondentEmailAddress: string): boolean {
    if (!this.previousRespondents || !this.respondents) {
      return false;
    }

    const foundRespondent = this.respondents.find(r => r.emailAddress.trim().toLowerCase() === respondentEmailAddress.trim().toLowerCase());
    if (foundRespondent) {
      return false;
    }

    return true;
  }

  onAddClicked(respondent: RespondentModel) {
    if (!respondent.emailAddress) return;
    this.selectedRespondentId = respondent.emailAddress;
    this.addClicked.emit(respondent);
  }
}
